import { useState } from "react";

const WiFi = () => {
  const [selectWiFi, setSelectWiFi] = useState(false);
  return (
    <div className="tooltip_wrapper">
      <svg
        className="wiFi"
        width="36"
        height="35"
        viewBox="0 0 36 35"
        fill={selectWiFi === false ? "none" : "#FDB935"}
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => {
          setSelectWiFi((prev) => !prev);
        }}
      >
        <rect
          x="0.5"
          y="0.5"
          width="35"
          height="33.1053"
          rx="4.5"
          stroke={selectWiFi === false ? "#292929" : "none"}
        />
        <path
          d="M27.4737 13.4662C27.2528 13.6749 27.0318 13.8837 26.8171 14.0988C26.6024 14.3139 26.4004 14.5416 26.1731 14.7883C23.8686 12.5552 21.16 11.3785 17.9906 11.3785C14.8337 11.3785 12.1378 12.5552 9.89644 14.7251C9.44817 14.2822 9.01883 13.8521 8.52637 13.3586C9.20825 12.8272 9.87118 12.2262 10.6099 11.7328C15.8692 8.24078 22.6501 8.84809 27.2338 13.2005C27.3096 13.2701 27.3917 13.3333 27.4737 13.3966C27.4737 13.4219 27.4737 13.4409 27.4737 13.4662Z"
          fill={selectWiFi === false ? "#292929" : "#F4F2F6"}
        />
        <path
          d="M17.6872 24.4738C17.6051 24.4358 17.523 24.3915 17.4346 24.3536C16.7654 24.0689 16.3929 23.3667 16.5318 22.6519C16.6707 21.9433 17.2957 21.4309 18.0218 21.4309C18.7416 21.4372 19.3666 21.956 19.4992 22.6645C19.6318 23.373 19.2467 24.0752 18.5711 24.3536C18.4827 24.3915 18.4006 24.4295 18.3122 24.4675C18.1039 24.4738 17.8955 24.4738 17.6872 24.4738Z"
          fill={selectWiFi === false ? "#292929" : "#F4F2F6"}
        />
        <path
          d="M12.5608 17.4011C12.1126 16.9583 11.6832 16.5344 11.2539 16.1043C14.5181 12.5616 20.8507 12.0935 24.7399 16.0663C24.3043 16.4965 23.8623 16.9266 23.4141 17.3695C21.9367 15.9524 20.1246 15.1553 17.9906 15.1617C15.8629 15.168 14.0572 15.9588 12.5608 17.4011Z"
          fill={selectWiFi === false ? "#292929" : "#F4F2F6"}
        />
        <path
          d="M22.1069 18.7675C21.6586 19.2103 21.2293 19.6405 20.8 20.0643C19.1142 18.4702 16.6834 18.641 15.225 20.058C14.7956 19.6278 14.3663 19.204 13.9307 18.7738C15.6606 16.7431 19.6319 16.2307 22.1069 18.7675Z"
          fill={selectWiFi === false ? "#292929" : "#F4F2F6"}
        />
      </svg>
      <div className="tooltip">WI-FI</div>
    </div>
  );
};

export default WiFi;
